module.exports = __webpack_public_path__ + "static/media/record-quality-spec.a8a65cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/record-quality-spec.png
// module id = 470
// module chunks = 0